const config = {
  apiUrl: window.REACT_APP_API_URL,
  env: window.REACT_APP_ENV,
  sentryDSN: window.REACT_APP_SENTRY_DSN,
  sentryEnv: window.REACT_APP_SENTRY_ENVIRONMENT,
  sentryRelease: window.REACT_APP_SENTRY_RELEASE,
}

export default config
